import { PoolButton } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SearchNotFoundIcon, SortingArrowLeftIcon } from '@synergy/theme-next';
import { Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { EmptyState } from '../../../components/empty-state/empty-state';
import { EmptyStateActions } from '../../../components/empty-state/empty-state-actions';
import { EmptyStateContent } from '../../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../../components/empty-state/empty-state-title';
import { openInquiryModal } from '../../../store/single-inquiry-actions';
import { useAppDispatch } from '../../../../store/store';

export const SearchPageEmptyState = (): ReactElement => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const handleClick = (): void => {
        navigate(-1);
    };

    const handleInquiry = (): void => {
        const search = searchParams.get('search') ?? undefined;
        dispatch(openInquiryModal({ items: [{ id: 1, articleName: search ?? '', quantity: null }] }));
    };

    return (
        <Stack sx={{ pt: 10, margin: 'auto' }}>
            <EmptyState icon={<SearchNotFoundIcon fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.empty.search.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage id="app.empty.search.content" />
                </EmptyStateContent>
                <EmptyStateActions>
                    <PoolButton variant="contained" fullWidth={true} onClick={handleInquiry}>
                        <PoolFormattedMessage id="app.singleInquiry" />
                    </PoolButton>
                    <PoolButton
                        variant="outlined"
                        startIcon={<SortingArrowLeftIcon />}
                        onClick={handleClick}
                        fullWidth={true}
                    >
                        <PoolFormattedMessage id="app.common.back" />
                    </PoolButton>
                </EmptyStateActions>
            </EmptyState>
        </Stack>
    );
};
